import { useEffect, useState } from "react"
import AppContext from "./AppContext"
import { data } from '../boot/config'

const AppProvider = ({children}) => {

      const [user, setUser] = useState([])

      async function getData(username){
            try{
                  const response = await fetch(`https://xatme.com/api/me/${username}`)
                  const result = await response.json()
                  setUser(result)
            }
            catch(err){
                  console.log('Error: ' + err)
            }
      }

      useEffect(() => {
            getData('tests')
      },  [])

      return <AppContext.Provider value={{user, data}}>{children}</AppContext.Provider>
}

export default AppProvider